export default __webpack_public_path__ + "static/media/9.b221f99f.jpg";